import { Action } from "redux";

export const UPDATE_CONTEXT = "UPDATE_CONTEXT";

export interface UpdateContextAction extends Action {
    context: string;
}

export const updateContextAction = (context: string): UpdateContextAction => {
    return {
        type: UPDATE_CONTEXT,
        context: context,
    };
};
